module.exports = __webpack_public_path__ + "img/c_6.dc7f871f.jpg";